module.exports = __webpack_public_path__ + "static/img/collection.66b6dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collection.png
// module id = hfNW
// module chunks = 1